<template>

    <div class="brush-record-page">

        <h2>刷脸记录</h2>

        <!-- 刷脸时间、人员、门禁设备等记录列表 -->

    </div>

</template>

<script>
 export default { name: 'BrushRecord' }
</script>

<style scoped>
.brush-record-page {
    padding: 20px;
}
</style>

